(function () {
  angular
    .module('specsguardApp')
    .controller('sgModulesTreeviewCtrl', sgModulesTreeviewCtrl);

  sgModulesTreeviewCtrl.$inject = ['$scope', '$log', 'Labels', '$state'];

  function sgModulesTreeviewCtrl ($scope, $log, Labels, $state) {
    $scope.filterInactive = (list) => list.filter((item) => item && item.active);
    // Used to determine if we allow changing the protected value
    $scope.currentState = $state.current.name;
    $scope.LABELS = Labels;

    $scope.projectLabel = Labels.getLabelLowerCase('project');
    $scope.buildingLabel= Labels.getLabelLowerCase('building');

    // First updates the client, then updates again with results coming back from the server.
    $scope.onDrop = function (list, movedItem, insertIndex) {
      const type = $scope.getIncludeType(list[0]);

      const updatedModuleOrElement = $scope.reorderClientModel(list, movedItem, insertIndex, type);
      $scope.saveReorder(updatedModuleOrElement, list).then((updatedModuleList) => {
        $scope.update(updatedModuleList, true);
      }).catch((err) => {
        $log.error('Error creating (sub)module', err);
      });

      return true;
    };

    // update and render to client
    $scope.reorderClientModel = function (list, movedItem, insertIndex, type) {
      let previousIndex = list.findIndex((item) => item._id === movedItem._id);
      // move item to other part in the array.
      if (insertIndex > previousIndex) {
        list.splice(insertIndex, 0, movedItem);
        list.splice(previousIndex, 1);
      } else {
        list.splice(previousIndex, 1);
        list.splice(insertIndex, 0, movedItem);
      }

      // adjust order parameter.
      if (type !== 'element') {
        let i = 0;
        list.forEach((item) => {
          item.order = i++;
          return item;
        });
      }

      return movedItem;
    };

    $scope.getListType = (item, moduleIndex) => {
      if (item.submoduleId) {
        return item.moduleId + item.submoduleId + moduleIndex + '-element';
      } else if (item.submodules) {
        return 'module';
      }
      // prepend parent id if it is provided
      return moduleIndex + '-submodule';
    };

    $scope.getIncludeType = (item) => {
      if (item.submoduleId) {
        return 'element';
      } else if (item.submodules) {
        return 'module';
      }
      return 'submodule';
    };

    $scope.showChildren = (item) => {
      item.hideChildren = !item.hideChildren;
    };

    $scope.allowedTypes = function (list, moduleIndex) {
      return [$scope.getListType(list[0], moduleIndex)];
    };

    $scope.postFix = function (item) {
      if (item.projectLevel === 1) {
        return $scope.projectLabel;
      } else if (item.projectLevel === 2) {
        return $scope.buildingLabel;
      }
      return '';
    };

    $scope.templateToolTip = function (item) {
      if (item.pveTemplates && item.pveTemplates.length > 0) {
        let templateNames = item.pveTemplates.map((item) => item.name);
        return templateNames.join('\n');
      }
      return Labels.getLabel('notemplatesavailable');
    }

    $scope.countActiveElements = function (item) {
      if (item.elements) {
        return item.elements.length;
      }
      else if (!item.elements.length) {
        return 0;
      }
      else {
        return item.elements.reduce(function (count, item) {
          return count + (item.active?1:0);
        }, 0);
      }
    }
  }
})();
